class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    if (!this.mainDetailsToggle.open) {
      this.stopPositionUpdates();
      return;
    }
    this.updateMenuPosition();
    window.addEventListener('resize', this.updateMenuPosition);
    window.addEventListener('scroll', this.updateMenuPosition, { passive: true });
    window.visualViewport?.addEventListener('resize', this.updateMenuPosition);
    this.headerResizeObserver ||= new ResizeObserver(this.updateMenuPosition);
    this.headerResizeObserver.observe(this.header, { box: 'border-box' });
  }

  updateMenuPosition = () => {
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  };

  stopPositionUpdates() {
    window.removeEventListener('resize', this.updateMenuPosition);
    window.removeEventListener('scroll', this.updateMenuPosition);
    window.visualViewport?.removeEventListener('resize', this.updateMenuPosition);
    this.headerResizeObserver?.disconnect();
  }

  disconnectedCallback() {
    this.stopPositionUpdates();
  }
}

customElements.define('header-menu', HeaderMenu);
